import React from "react";
import Image from "react-bootstrap/Image";
// import axios from "axios";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
// import { serverApi } from "../../../../../config/Keys";
import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import SimpleReactLightbox from "simple-react-lightbox";

export const MenuSetupScreen = ({
  onPageChangeHandlerClosed,
  onDrop,
  onMenuSetupSubmit,
  children,
}) => {
  return (
    <React.Fragment>
      <div className="display-toggle-stepup-button">
        <RightSidePannel selectedTab={4} />
      </div>
      <div>
        <TopTextReusableComponent headingText="Menu Set up" />
        <div className="top-seating-area-heading mt-5 mb-5">
          <h4 className="big-heading-text">Upload your menu</h4>
          <p className="small-heading-text">
            (Please include all the seating areas in your food facility)
          </p>
        </div>
        <hr />
        <SimpleReactLightbox>
          {/* <MultipleImageUploadComponent
            title="Upload Menu 21"
            smallTitle="(You can upload the menu from restaurant in JPEG, PNG, PDF or
            Word Formats)"
            onDrop={onDrop}
            imageExtension={[".jpg", ".gif", ".png", ".jpeg"]}
          /> */}
          {children}
        </SimpleReactLightbox>
        <div className="onboarding-map-setup-screen-autodetect-button">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            onClick={onPageChangeHandlerClosed}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={onMenuSetupSubmit}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default MenuSetupScreen;

// /**************************************
//  * @DESC - ON IMAGE UPLOAD HANDLER
//  * @DESC - USER DEFINED METHODS
//  **************************************/
// onImageUploadHandler = (e) => {
//   this.setState({ loader: true });
//   const data = new FormData();
//   data.append("image", e.target.files[0]);
//   axios
//     .post(`${serverApi}/image/upload-content-images`, data)
//     .then((res) => {
//       let uploadMenu = this.state.uploadMenu;
//       uploadMenu.push(res.data.image_URL);
//       this.setState({ uploadMenu: uploadMenu, loader: false });
//     })
//     .catch((err) => {
//       this.setState({ loader: false });
//       window.alert("Error while uploading the image");
//     });
// };

// <div className="file_upload mt-3">
//           <div className="file-lable-text">
//             <label>Upload Menu</label>
//             <p>
//               ( You can upload the menu from restaurant in JPEG, PNG, PDF or
//               Word Formats)
//             </p>
//           </div>
//           <div className="col-12 p-0">
//             <div
//               className="view_chainsBor restaurant_details_onboarding_file_upload"
//               style={{ width: "100%" }}
//             >
//               <div className="custom_file_upload restaurant_details_onboarding_custom_file_upload">
//                 <input
//                   type="file"
//                   name="iconone"
//                   id="filetwo"
//                   onChange={this.onImageUploadHandler}
//                   className="custom_input_upload"
//                 />
//                 <label
//                   className="custom_input_label newChain_add"
//                   htmlFor="filetwo"
//                 >
//                   <div>
//                     <i
//                       className="fa fa-plus"
//                       style={{ color: "#CCCCCC" }}
//                     ></i>
//                   </div>
//                 </label>
//               </div>
//               <div className="newChain_addthree">
//                 {this.state.uploadMenu.length > 0
//                   ? this.state.uploadMenu.map((image, index) => (
//                       <img
//                         key={index}
//                         src={image}
//                         className="newChain_addtwo"
//                         style={{
//                           height: "100%",
//                           width: "100%",
//                         }}
//                         alt="chain "
//                       />
//                     ))
//                   : null}
//               </div>
//             </div>
//           </div>
//         </div>
